import { AppSettings } from "appSettings/appSettings.dev";
import { DatasheetReport, EmployeeReport, ChildrenReport, RelativeReport } from "types";
import { BaseService } from "./BaseService";

class ReportsService {
  private baseService: BaseService;
  constructor() {
    this.baseService = new BaseService(AppSettings.apiURL);
  }

  async getEmployees({ businessUnitCode, status, finalDate }: DatasheetReport): Promise<EmployeeReport[]> {
    const response = await this.baseService.get<EmployeeReport[]>(
      `DataSheets/GetEmployees?businessUnitCode=${businessUnitCode}&status=${status}&finalDate=${finalDate}`
    );
    return response?.data ?? [];
  }

  async getChidren({ businessUnitCode, status, finalDate }: DatasheetReport): Promise<ChildrenReport[]> {
    const response = await this.baseService.get<ChildrenReport[]>(
      `DataSheets/GetChildren?businessUnitCode=${businessUnitCode}&status=${status}&finalDate=${finalDate}`
    );
    return response?.data ?? [];
  }

  async getRelatives({ businessUnitCode, status, finalDate }: DatasheetReport): Promise<RelativeReport[]> {
    const response = await this.baseService.get<RelativeReport[]>(
      `DataSheets/GetRelatives?businessUnitCode=${businessUnitCode}&status=${status}&finalDate=${finalDate}`
    );
    return response?.data ?? [];
  }
}

export const reportsService = new ReportsService();
